import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=1c92a4ca"
import script from "./ProjectsView.vue?vue&type=script&lang=js"
export * from "./ProjectsView.vue?vue&type=script&lang=js"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=1c92a4ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports